import { ItemContratoInstrumentoCalibracao } from './ItemContratoInstrumentoCalibracao';
export class ItemDadoEditavelTree {
  constructor({
    prazoEntrega,
    sequencia,
    tipoCalibracao,
    tipoCalibracaoNome,
    localExecucao,
    localExecucaoNome,
    flagAdicionadoCliente = false,
    faixa,
    tipoInstrumentoNome,
    item,
  }) {
    this.faixa = item.faixa || faixa;
    this.prazoEntrega = Number(prazoEntrega);
    this.sequencia = sequencia++;
    this.numeroItem = sequencia;
    this.tipoCalibracaoId = tipoCalibracao;
    this.tipoCalibracaoNome = tipoCalibracaoNome;
    this.localExecucaoId = localExecucao;
    this.localExecucaoNome = localExecucaoNome;
    this.flagAdicionadoCliente = flagAdicionadoCliente;
    this.codigo = item.data;
    this.info = '';
    this.tipoInstrumentoNome = item.tipoInstrumentoNome || tipoInstrumentoNome;
    this.instrumentoId = item.key;
    this.frequenciaCalibracaoEmMeses = item.frequenciaCalibracao;
    this.contratoInstrumentoServicoCalibracao =
      this.formatContratoInstrumentoServicoCalibracao(item);
  }

  formatContratoInstrumentoServicoCalibracao(item) {
    return new ItemContratoInstrumentoCalibracao({
      ...item,
      ...item.children[0],
      flagRemovidoCliente: item.children[0].flagRemovidoCliente || null,
      servicoId: item.children[0].servicoId,
    });
  }
}
